import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"

import _ from 'lodash'
import ogImage from "../../images/posts/67/thumb-landscape.jpg"

const Post67 = ({ data: { allCategoryJson, postsJson }, location }) => {

  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>バッグを買うとき、必ず訪れるあの瞬間。</p>
          <p>——小さいほうが可愛い。<br></br>
          ——でも、ちゃんと入る？</p>
          <p>見た目に惹かれてミニバッグを選んだのに、結局サブバッグを持つことになった経験。<br></br>
          逆に、安心感を優先して大きめを選んだら、気づけばクローゼットで眠ったままになっていた——そんなことも。</p>
          <p>大人になるほど、バッグ選びは難しくなります。<br></br>
          だからこそ今、多くの人の共感を集めているのが、<br></br>
          <b className="text-font-bolder">CELINEの「Nino (ニノ) 」</b>。</p>
          <p>クラシックなのに今っぽく、きちんとしているのに頑張りすぎて見えない。<br></br>
          日常のスタイルに自然と寄り添いながら、装い全体を洗練させてくれる存在です。</p>
          <p>今回は人気の<b className="text-font-bolder">「ティーン ニノ」</b>と<b className="text-font-bolder">「ミディアム ニノ」</b>を比較しながら、<br></br>
          実際の収納力はもちろん、スタイリングの印象や使い心地までリアルな視点でご紹介します。</p>
          <p>「自分に合うサイズはどっち？」<br></br>
          そんなバッグ選びの悩みを解決するための、サイズ比較ガイドです。</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2 style={{color: "#0a9186"}}>目次</h2>
        <p>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>1 |</span>&nbsp;&nbsp;なぜCELINE「ニノ」は、いま選ばれているのか？</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec2" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;端正でタイムレスなフォルム</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec3" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;アイコンとして際立つ、トリオンフモチーフ</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec4" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;美しさを守る、底鋲（スタッズ）ディテール</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec5" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>2 |</span>&nbsp;&nbsp;「今日は荷物を軽くしたい」日に選びたいティーン ニノ</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec6" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ティーン ニノ｜「身軽さ」と「完成度」を両立する、コンパクトなバッグ</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec7" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ティーン ニノが映える大人カジュアル</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec8" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>3 |</span>&nbsp;&nbsp;「結局こればかり使う」ミディアム ニノの安心感</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec9" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ミディアム ニノ｜「余裕」と「安心感」をくれる、頼れる日常バッグ</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec10" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ミディアム ニノが映える上品オフィスコーデ</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec11" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>4 |</span>&nbsp;&nbsp;サイズで選ぶ、ニノという選択</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec12" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ティーン ニノ｜軽やかさと今らしさを楽しみたい方に</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec13" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ミディアム ニノ｜安心感と実用性を重視したい方に</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec14" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>5 |</span>&nbsp;&nbsp;まとめ：バッグは、"今の自分"にちょうどいいものを</ScrollLink>
          </div>
        </p>
      </div>
      <section name="sec1" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/67/1.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>なぜCELINE「ニノ」は、いま選ばれているのか？</h2>
        </div>
        <p>CELINEの「ニノ」が多くの支持を集めている理由は、デザイン性・実用性、そして"今の時代感"のバランスが、非常に高いレベルで成立している点にあります。</p>
        <p>クラシックな気品を感じさせながらも、どこか現代的で、主張しすぎないのに、装い全体を自然と洗練させてくれる存在感です。一目でトレンドと分かるバッグとは異なり、ニノは持つ人自身のスタイルを引き立てる側に回るバッグです。</p>
        <p>特に支持しているのは、<br></br>
        「ファッション感度の高い30〜40代を中心とした大人世代」<br></br>
        「トレンドを理解しながらも"長く使えるもの"を選びたい人」<br></br>
        「ブランドロゴの強さより"センスの良さ"を重視する層」</p>
        <p>SNSやファッション誌で流行を追いながらも、「次に選ぶなら本当に使えるものを」と考える女性たちにとって、ニノは非常に理想的な選択肢となっています。</p>
        <p>通勤、学校行事、週末のお出かけまでシーンを問わず活躍する柔軟さは、ライフステージが変化しても寄り添い続けてくれます。</p>
        <p>流行のためだけではなく、トレンド感がありながらも長く使い続けられる点も魅力です。ニノの魅力は、"今っぽさ"と"日常性"が無理なく共存しているところにあります。旬のスタイリングにも自然になじみ、数年後に持っていても古く見えにくいデザインは、日常のスタメンバッグとして気づけば手に取る機会が増えるそんな存在です。</p>
        <p>毎日の装いにすっとなじみ、使うたびに「選んでよかった」と感じられる点も、多くの支持を集めている理由のひとつです。</p>
        <div name="sec2" className="mt8">
          <div>
            <h3>◆ 端正でタイムレスなフォルム</h3>
          </div>
          <div className="text-img-cloumn-main">
            <figure>
              <StaticImage src="../../images/posts/67/2.jpg" alt=""/>
            </figure>
            <div>
              <p>ニノの魅力は、無駄を削ぎ落とした構築的なシルエットにもあります。<br></br>
              直線的でありながら柔らかさを感じるフォルムは、どの角度から見てもバランスが美しく、手に持った瞬間にスタイル全体を整えてくれます。</p>
              <p>流行に左右されにくい端正なデザインは、年齢やトレンドの変化にも自然に対応できます。<br></br>
              数年後も違和感なく持ち続けられる完成度の高さが、長く愛用される理由となっています。</p>
            </div>
          </div>
        </div>
        <div name="sec3" className="mt4">
          <div>
            <h3>◆ アイコンとして際立つ、トリオンフモチーフ</h3>
          </div>
          <div className="text-img-cloumn-main">
            <figure>
              <StaticImage src="../../images/posts/67/3.jpg" alt=""/>
            </figure>
            <div>
              <p>ニノの印象を決定づけているのが、フロントに配されたトリオンフモチーフ。<br></br>
              パリの凱旋門を囲むチェーンから着想を得たこのデザインは、CELINEを象徴するアイコンとして長く受け継がれてきました。</p>
              <p>ジュエリーのような存在感を放ちながらも、過度な主張にならない絶妙なサイズ感です。<br></br>
              バッグそのものを装飾するのではなく、持つ人のスタイルを引き立てる役割を果たしています。</p>
              <p>ブランドロゴを語らずとも品格が伝わる——<br></br>
              そんな知性あるラグジュアリーを体現するディテールです。</p>
            </div>
          </div>
        </div>
        <div name="sec4" className="mt4">
          <div>
            <h3>◆ 美しさを守る、底鋲（スタッズ）ディテール</h3>
          </div>
          <div className="text-img-cloumn-main">
            <figure>
              <StaticImage src="../../images/posts/67/4.jpg" alt=""/>
            </figure>
            <div>
              <p>バッグの底面には底鋲（スタッズ）が施されており、床やテーブルに置いた際もレザーが直接触れにくい仕様になっています。これにより、擦れや汚れを軽減し、美しい状態を長く保ちやすくなっています。</p>
              <p>外出先でバッグを置くシーンは意外と多いもの。<br></br>
              カフェやレストラン、オフィスなどでも気兼ねなく扱える安心感は、日常的に使うバッグだからこそ重要なポイントです。</p>
              <p>さらに、底鋲があることでバッグが安定して自立しやすく、所作までスマートに見えるのも魅力のひとつです。</p>
            </div>
          </div>
        </div>
      </section>
      <section name="sec5" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/67/5.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>「今日は荷物を軽くしたい」日に選びたいティーン ニノ</h2>
        </div>
        <p>最初に感じるのは、想像以上のコンパクトさです。<br></br>
        けれど不思議なのは、決して"物足りなく"見えないこと。<br></br>
        むしろ持った瞬間、コーディネート全体が整う感覚があります。</p>
        <div name="sec6" className="mt8">
          <div className="img-three-cloumn gap mt8">
            <figure className="img-small">
              <StaticImage src="../../images/posts/67/6.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/67/7.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/67/8.jpg" alt=""/>
            </figure>
          </div>
          <span className="text-center">CELINE / ティーン ニノ / W20 × H13 × D8 (cm)</span>
          <div className="mt4">
            <h3>◆ ティーン ニノ｜「身軽さ」と「完成度」を両立する、コンパクトなバッグ</h3>
            <p>スマートフォン、ミニ財布、鍵、リップ、イヤホンなど、必要最低限のアイテムが無理なく収まり、バッグの中でも美しく整理できる設計です。</p>
            <p>内側には仕切りやジップポケットが備えられており、小ぶりでありながら中身が散らかりにくいのも魅力です。必要なものをすぐ取り出せる使いやすさは、日常の小さなストレスを感じさせません。</p>
            <p>また、コンパクトなサイズ感だからこそ、斜め掛けにしたときもスタイリングの邪魔をせず、全身のバランスを軽やかに見せてくれます。</p>
          </div>
        </div>
        <div name="sec7" className="mt8">
          <figure>
            <StaticImage src="../../images/posts/67/9.jpg" alt=""/>
          </figure>
          <div className="mt4">
            <h3>◆ ティーン ニノが映える大人カジュアル</h3>
            <p>カジュアルな装いにも、きれいめスタイルにも自然になじみ、「今日は身軽に過ごしたい」という日にちょうどいい存在です。</p>
            <p>例えばこんな日、<br></br>
            「子どもの送り迎え後、そのままランチへ」<br></br>
            「週末のショッピング」<br></br>
            「旅行先の街歩き」</p>
            <p>荷物を減らすことで、気分まで軽くなる——。<br></br>
            ティーン ニノは、そんな心地よい身軽さを叶えてくれるバッグといえます。</p>
          </div>
        </div>
      </section>
      <section name="sec8" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/67/10.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>「結局こればかり使う」ミディアム ニノの安心感</h2>
        </div>
        <p>一方で、多くの大人女性が本音で求めているのは、"余裕"です。<br></br>
        必要なものを無理なく持ち歩けること、そしてどんな予定にも慌てず対応できる安心感。</p>
        <p>仕事帰りの予定や急な外出、長時間のお出かけなど、一日の行動範囲が広がるほどバッグに求める役割も増えていきます。だからこそ、「入るかどうか」を気にせず使えるサイズ感は、日常のストレスをさりげなく減らしてくれます。</p>
        <div name="sec9" className="mt8">
          <div className="img-three-cloumn gap">
            <figure className="img-small">
              <StaticImage src="../../images/posts/67/11.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/67/12.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/67/13.jpg" alt=""/>
            </figure>
          </div>
          <span className="text-center">CELINE / ミディアム ニノ / W25 × H17 × D10 (cm)</span>
          <div className="mt4">
            <h3>◆ ミディアム ニノ｜「余裕」と「安心感」をくれる、頼れる日常バッグ</h3>
            <p>長財布にポーチ、ハンカチ。<br></br>
            ハンドクリームやイヤフォンなど、外出時間が長くなるほど持ち物は自然と増えていきます。<br></br>
            そんな日常に寄り添ってくれるのが、ニノの優れた収納設計です。</p>
            <p>バッグを横から見ると、ニノならではの美しい立体感と構築的なフォルムが際立ちます。程よいマチ幅によって収納力をしっかり確保しながらも、膨らみすぎないすっきりとしたシルエットを実現。荷物を入れても形が崩れにくく、常に端正な印象を保ちやすいデザインです。</p>
            <p>また、トップハンドルとショルダーストラップのバランスも計算されており、ハンドバッグとしてもクロスボディとしても自然に持てる仕様です。シーンやスタイリングに合わせて持ち方を変えられる点も、日常使いしやすい魅力のひとつです。</p>
            <p>気づけば「結局これを選んでいる」。<br></br>
            ミディアム ニノは、そんな安心感を日常にもたらしてくれるバッグといえます。</p>
          </div>
        </div>
        <div name="sec10" className="mt8">
          <figure>
            <StaticImage src="../../images/posts/67/14.jpg" alt=""/>
          </figure>
          <div className="mt4">
            <h3>◆ ミディアム ニノが映える上品オフィスコーデ</h3>
            <p>仕事の日も、予定が詰まった休日も、バッグを替えずに出かけられる。</p>
            <p>きれいめシャツに落ち着いたトーンのパンツスタイルなど、オフィスコーデにも自然になじみ、全体の印象を上品に引き締めてくれます。</p>
            <p>このストレスのなさは想像以上。<br></br>
            気づけば——「今日もこれでいいか」ではなく「今日もこれがいい」になるバッグです。</p>
            <p>例えばこんな日、<br></br>
            「朝はオフィスでの打ち合わせ、夕方はそのまま会食へ」<br></br>
            「仕事終わりに友人とディナーの予定」<br></br>
            「平日はきちんと、休日はきれいめカジュアルで過ごしたい日」</p>
            <p>きちんと感と余裕を両立したい日に、自然と手に取りたくなる存在です。</p>
          </div>
        </div>
      </section>
      <section name="sec11" className="section-content">
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/67/15.jpg" alt=""/>
            <span className="text-center">ティーン ニノ</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/67/16.jpg" alt=""/>
            <span className="text-center">ミディアム ニノ</span>
          </figure>
        </div>
        <div className="table-rounded-bg">
          <div className="table-wrap">
            <table className="table-rounded">
              <thead>
                <tr>
                  <th></th>
                  <th>ティーン ニノ</th>
                  <th>ミディアム ニノ</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>サイズ (cm)</th>
                  <td>W20 × H13 × D8</td>
                  <td>W25 × H17 × D10</td>
                </tr>
                <tr>
                  <th>収納目安</th>
                  <td>スマホ / ミニ財布 / 鍵 / リップ / イヤフォン</td>
                  <td>長財布 / ポーチ / ハンカチ / コスメ / 鍵 / イヤフォン</td>
                </tr>
                <tr>
                  <th>おすすめシーン</th>
                  <td>休日 / ショッピング / 荷物が少ない日</td>
                  <td>通勤 / 外出時間が長い日 / 荷物が多い日</td>
                </tr>
                <tr>
                  <th>持ち方</th>
                  <td>ハンド / ショルダー / クロスボディ対応</td>
                  <td>ハンド / ショルダー / クロスボディ対応</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="mt8">
          <h2>サイズで選ぶ、ニノという選択</h2>
        </div>
        <p>同じ「ニノ」でも、サイズが変わることで使い心地や印象は大きく異なります。ライフスタイルや持ち物の量に合わせて選べる点も、多くの女性に支持されている理由のひとつです。</p>
        <div name="sec12" className="mt4">
          <h3>◆ ティーン ニノ｜軽やかさと今らしさを楽しみたい方に</h3>
          <p>必要最低限の持ち物をスマートに収められるコンパクトサイズです。<br></br>
          斜め掛けでもバランスよく収まり、コーディネート全体を軽やかに見せてくれます。<br></br>
          休日のお出かけや身軽に過ごしたい日に自然と手が伸びる存在です。</p>
        </div>
        <div name="sec13" className="mt4">
          <h3>◆ ミディアム ニノ｜安心感と実用性を重視したい方に</h3>
          <p>日常的に持ち歩くアイテムをしっかり収納できるサイズ感です。<br></br>
          荷物が増えてもフォルムが崩れにくく、通勤から外出まで幅広いシーンで活躍します。<br></br>
          「結局こればかり使う」と感じさせる、安定した使いやすさが魅力です。</p>
        </div>
      </section>
      <section name="sec14" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/67/17.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>まとめ：バッグは、"今の自分"にちょうどいいものを</h2>
        </div>
        <p>バッグを変えるだけで、不思議と日常の気分は変わります。<br></br>
        忙しい毎日の中で、自分のために時間をかけて選ぶものは意外と多くありません。</p>
        <p>だからこそ、毎日手に取るバッグは少し特別な存在です。<br></br>
        朝、自然と手が伸びる。<br></br>
        鏡に映った自分を見て、ほんの少し気分が整う。<br></br>
        そんな小さな高揚感を与えてくれるのが、CELINE「ニノ」です。</p>
        <p>無理に背伸びをしなくても、洗練されて見える。<br></br>
        頑張りすぎなくても、きちんとした印象が叶う。</p>
        <p>それこそが、今の大人にとって理想のバッグなのかもしれません。<br></br>
        サイズ選びに迷ったときは、ライフスタイルを基準に考えてみてください。</p>
        <p>身軽に過ごしたい日や、トレンド感を楽しみたいなら<b className="text-font-bolder">ティーン ニノ</b>。<br></br>
        通勤や外出時間が長く、安心感や実用性を重視したいなら<b className="text-font-bolder">ミディアム ニノ</b>。</p>
        <p>どちらを選んでも間違いではありません。</p>
        <p>ただひとつ言えるのは——<br></br>
        ニノを持つことで、毎日の装いにほんの少し自信が生まれ、気分まで前向きに整うということ。</p>
        <p>何気ない一日でも、バッグひとつで心の高揚感は変わります。<br></br>
        その小さな変化こそが、大人のバッグ選びにおけるいちばんの価値なのかもしれません。</p>
        <p className="mt4"><span className="text-border-bottom">CELINE（セリーヌ）《Nino (ニノ) 》はどこで借りられる？</span></p>
        <p>価格も高額で、簡単には手に取りにくいセリーヌのバッグ。<br></br>
        「試してみたいけれど、買うには勇気がいる」──そんな方におすすめなのが、ブランドバッグシェアリングサービス「ラクサス」です。<br></br>
        アプリで簡単に注文でき、自宅にいながら憧れのブランドバッグを楽しめます。</p>
        <div className="border"></div>
        <p>📱憧れを日常に──ラクサスでセリーヌを体験しよう！</p>
        <Link to="https://laxus.co/app/pc/bags/celine" className="view-all-button">セリーヌのバッグはこちら</Link>
      </section>
    </section>
    </div>
  </div>
</Layout>
)}

export default Post67

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 67}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
